import { message } from 'antd'
import React, { useEffect, useState } from 'react'
import TournamentMenuBar from './display/TournamentMenuBar'
import TournamentProcess from './display/TournamentProcess'
import { saveTournament } from '../../shared/restClient'

const TournamentDisplay = (props) => {
  const [tournament, setTournament] = useState({})
  const [workingTournament, setWorkingTournament] = useState({})
  const [currentSchedule, setCurrentSchedule] = useState(0)
  const [canNext, setCanNext] = useState(true)
  const [canPrev, setCanPrev] = useState(false)
  const [canGoLive, setCanGoLive] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    setTournament(props.tournament)
    setWorkingTournament(props.tournament)

    const { currentSchedule: schedule } = props?.tournament

    if (schedule) {
      setCurrentSchedule(schedule)
      setCanNext(schedule < props.tournament.schedule.length - 1)
      setCanPrev(schedule > 0 && !props.tournament?.completed)
    }
    setIsLoaded(true)
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    async function updateTournament () {
      const tournamentData = Object.assign({}, workingTournament, { currentSchedule })
      setTournament(tournamentData)
      await saveTournament(tournamentData)
    }

    if (isLoaded) {
      updateTournament().then(() => { console.log('current step changed') }).catch((err) => { console.log(err) })
    }
    console.log(currentSchedule)
    console.log(workingTournament)

    // eslint-disable-next-line
  }, [currentSchedule])

  const handleCurrentScheduleChange = (schedule) => {
    setCanNext(schedule < workingTournament.schedule.length - 1)
    setCanPrev(schedule > 0 && !workingTournament?.completed)
    const tournamentData = Object.assign({}, workingTournament, { currentSchedule })
    setTournament(tournamentData)
    setCurrentSchedule(schedule)
  }

  const handleStepStart = () => {
    setCanNext(false)
  }

  const handleStepFinish = () => {
    setCanNext(currentSchedule <= tournament.schedule.length - 1)
  }

  const handleSave = async (data) => {
    const tournamentData = Object.assign({}, workingTournament, data)
    await saveTournament(tournamentData)
    setTournament(tournamentData)
    if (data?.completed) {
      setCanPrev(false)
    }
    props.onUpdate(tournamentData)
    message.success('Save completed')
  }

  const handleTournamentUpdate = (data) => {
    setWorkingTournament(data)
  }

  return (
    <>
      {!tournament.completed
        ? (
          <TournamentMenuBar onScheduleChange={handleCurrentScheduleChange} currentStep={currentSchedule} canNext={canNext} canPrev={canPrev} onSave={handleSave} onUpdate={handleTournamentUpdate} tournament={tournament} isDone={currentSchedule === tournament?.schedule?.length} canGoLive={canGoLive} />
          )
        : ''}
      <TournamentProcess tournament={tournament} currentStep={currentSchedule} onTournamentUpdate={handleTournamentUpdate} onStepStart={handleStepStart} onStepFinish={handleStepFinish} onUpdate={props.onUpdate} canGoLive={setCanGoLive} />
    </>
  )
}

export default TournamentDisplay
